import styled from "styled-components";

export const CompleteDataWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 150px;
  width: 100%;
  min-height: 100vh;
  @media only screen and (min-width: 1400px) {
    flex-direction: row;
    padding-top: 0;
  }
`;
